import { Link } from "react-router-dom";
import Logo from "./Logo";

export default function Footer() {
  return (
    <footer className="border-t border-black/5 bg-cream" data-testid="site-footer">
      <div className="mx-auto max-w-6xl px-5 py-12 lg:px-8">
        <div className="flex flex-col items-start gap-6 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-center gap-6">
            <Logo />
            <a
              href="mailto:support@dinewithdishly.co"
              data-testid="footer-contact-email"
              className="text-[14px] font-medium text-charcoal/70 hover:text-terracotta"
            >
              support@dinewithdishly.co
            </a>
          </div>
          <nav className="flex flex-wrap items-center gap-5 text-[14px] font-medium text-charcoal/70">
            <Link data-testid="footer-privacy" to="/privacy" className="hover:text-terracotta">Privacy</Link>
            <Link data-testid="footer-terms" to="/terms" className="hover:text-terracotta">Terms</Link>
            <Link data-testid="footer-help" to="/support" className="hover:text-terracotta">Help</Link>
            <Link data-testid="footer-delete" to="/delete-account" className="hover:text-terracotta">Delete Account</Link>
          </nav>
        </div>
        <p className="mt-8 text-[12px] leading-relaxed text-charcoal/45">
          © 2026 Dishly · Real Food. Made Local. · Apple and the App Store are trademarks of Apple Inc. · Google Play and the Google Play logo are trademarks of Google LLC.
        </p>
      </div>
    </footer>
  );
}
